import cx from "classnames";

import { Button, Flex } from "@theorgchartdev/storybook";
import { useReportingContext } from "@/providers/ReportsProvider";
import { appstr } from "@coreapp/utils/appstr";

export const FilterReportsActions = () => {
  const { SaveReportChanges, isSaving, isSearching, DoSearch } = useReportingContext();

  const runSearch = () => {
    DoSearch();
  };

  const handleSaveAndRun = () => {
    runSearch();
    SaveReportChanges();
  };

  const handleRun = () => {
    runSearch();
  };

  return (
    <div className={cx("sidebar-header-buttons", "sidebar-content-item--divider")}>
      <Flex width="100px">
        <Button
          dataTestId="filter--save-run-btn"
          isFullWidth
          modifier={"secondary"}
          size={"small"}
          loading={isSaving || isSearching}
          onClick={handleSaveAndRun}
        >
          {appstr("Save and run")}
        </Button>
      </Flex>
      <Flex width="100px">
        <Button
          dataTestId={"filter--run-btn"}
          isFullWidth
          className={cx("oc-special-secondary", "oc-special-secondary--fit")}
          modifier={"secondary"}
          size={"small"}
          loading={isSearching}
          onClick={handleRun}
        >
          {appstr("Run")}
        </Button>
      </Flex>
    </div>
  );
};
